export default function FilmingSvg({ width }) {
  return (
    <svg
      id="ea1a5787-4807-42ae-aba3-2738e8ad7f96"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width ?? "500"}
      viewBox="0 0 1150.44 675.56">
      <defs>
        <linearGradient
          id="b40d0b21-e963-4952-8000-4d7b7531dbb4"
          x1="501.81"
          y1="766.64"
          x2="501.81"
          y2="122.51"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="gray" stop-opacity="0.25" />
          <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
          <stop offset="1" stop-color="gray" stop-opacity="0.1" />
        </linearGradient>
      </defs>
      <title>videographer</title>
      <path
        d="M1144.41,739.72c-1.08.79-2.19,1.55-3.31,2.3a111,111,0,0,1-12.91,7.45c-23.46,11.7-52.36,17.41-80.52,21.29-63.15,8.72-127.63,10.41-191.84,12.07-173.47,4.51-347.4,9-520.43-1.38-68.36-4.1-138.25-11-200.21-32q-13.31-4.51-26.12-9.94c-17.26-7.35-33.84-16.28-47.63-26.92-13-10-23.46-21.5-29.74-34.56-13.1-27.22-6.17-57.79,8.78-84.46a261.06,261.06,0,0,1,21-31C73,547.55,85.71,533,97.33,518c41.32-53.42,68.28-120.89,30.14-175.61-11-15.72-26.81-29.52-35.74-45.93-11.41-21-10.52-44.31-6.89-67,.46-2.86,1-5.7,1.49-8.54,6.23-33.57,17.83-69.75,53.74-90.71,37.3-21.78,90.25-20.68,136.56-12.89,72,12.12,138.42,37.43,205.49,60.29s137.32,43.74,211.08,46c65.12,2,141.09-12.87,184.31-51.46,42-37.48,120.9-40.33,177.8-17.69,39,15.54,68.15,43.53,80.44,75A93.74,93.74,0,0,1,1141.1,249a85.52,85.52,0,0,1,1,18.43c-.17,3-.5,6.05-1,9-9.5,62.13-77.91,111.13-119.49,166.63-20.32,27.11-34.67,59.67-20.7,88.9,21.31,44.54,95.42,60.37,140.19,93.53a102.23,102.23,0,0,1,22,21.34C1184.75,676.35,1176.74,716.19,1144.41,739.72Z"
        transform="translate(-24.78 -112.22)"
        fill="#00629c"
        opacity="0.1"
      />
      <ellipse
        cx="537.69"
        cy="650.7"
        rx="269.64"
        ry="9.16"
        fill="#00629c"
        opacity="0.1"
      />
      <g id="55bfdb31-36b5-4718-97dd-773b4157bdc7" data-name="flowers">
        <path
          d="M776.7,756.82s58-73.47,53.51-146.5c-1.89-30.66,5.66-61.18,22.53-86.85A237.89,237.89,0,0,1,880,489.42"
          transform="translate(-24.78 -112.22)"
          fill="none"
          stroke="#535461"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          d="M877.43,443.37c-4.1,10.22,2.49,47.26,2.49,47.26s30.39-22.19,34.49-32.4a19.93,19.93,0,0,0-37-14.86Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M824.14,487.66c2.11,10.8,27.78,38.31,27.78,38.31s13.45-35.14,11.34-45.94a19.93,19.93,0,0,0-39.12,7.63Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M786.65,584.86c7.27,8.26,43.31,19,43.31,19s-6.13-37.12-13.4-45.38a19.92,19.92,0,1,0-29.91,26.33Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M774.83,664.79c5.77,9.37,39.48,26.1,39.48,26.1s.23-37.63-5.54-47a19.93,19.93,0,1,0-33.94,20.9Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M890,543.55c-10.19,4.17-47.27-2.17-47.27-2.17s22-30.54,32.16-34.71A19.93,19.93,0,0,1,890,543.55Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M875,636.85c-11,.94-44.46-16.21-44.46-16.21s30.11-22.56,41.07-23.5A19.93,19.93,0,1,1,875,636.85Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M847.92,725.54c-10.65,2.77-46.55-8.47-46.55-8.47s25.86-27.32,36.51-30.1a19.93,19.93,0,0,1,10,38.57Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M877.43,443.37c-4.1,10.22,2.49,47.26,2.49,47.26s30.39-22.19,34.49-32.4a19.93,19.93,0,0,0-37-14.86Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M824.14,487.66c2.11,10.8,27.78,38.31,27.78,38.31s13.45-35.14,11.34-45.94a19.93,19.93,0,0,0-39.12,7.63Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M786.65,584.86c7.27,8.26,43.31,19,43.31,19s-6.13-37.12-13.4-45.38a19.92,19.92,0,1,0-29.91,26.33Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M774.83,664.79c5.77,9.37,39.48,26.1,39.48,26.1s.23-37.63-5.54-47a19.93,19.93,0,1,0-33.94,20.9Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M890,543.55c-10.19,4.17-47.27-2.17-47.27-2.17s22-30.54,32.16-34.71A19.93,19.93,0,0,1,890,543.55Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M875,636.85c-11,.94-44.46-16.21-44.46-16.21s30.11-22.56,41.07-23.5A19.93,19.93,0,1,1,875,636.85Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M847.92,725.54c-10.65,2.77-46.55-8.47-46.55-8.47s25.86-27.32,36.51-30.1a19.93,19.93,0,0,1,10,38.57Z"
          transform="translate(-24.78 -112.22)"
          opacity="0.25"
        />
        <path
          d="M777.2,753.75S860,710.1,885.48,641.51c10.7-28.8,30-53.64,55.79-70.27A238.59,238.59,0,0,1,980,551.15"
          transform="translate(-24.78 -112.22)"
          fill="none"
          stroke="#535461"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          d="M996.3,508c-7.88,7.67-16.87,44.21-16.87,44.21s36.77-8,44.66-15.64A19.93,19.93,0,0,0,996.3,508Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M929.64,526.91c-2.45,10.73,9.87,46.28,9.87,46.28s26.53-26.67,29-37.4a19.93,19.93,0,1,0-38.85-8.88Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M856,600.58c3.3,10.5,31.88,35,31.88,35s9.44-36.42,6.14-46.92a19.93,19.93,0,1,0-38,12Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M812.78,668.87c1.48,10.9,25.51,39.85,25.51,39.85s15.46-34.3,14-45.21a19.93,19.93,0,1,0-39.5,5.36Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M967.15,604.67c-11-.31-42.34-21.14-42.34-21.14s32.47-19,43.47-18.7a19.93,19.93,0,0,1-1.13,39.84Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M915.63,683.89c-10.4-3.59-34.07-32.83-34.07-32.83s36.66-8.43,47.07-4.84a19.93,19.93,0,0,1-13,37.67Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
        <path
          d="M855,754c-10.86-1.78-39.14-26.6-39.14-26.6s34.72-14.51,45.58-12.73A19.93,19.93,0,0,1,855,754Z"
          transform="translate(-24.78 -112.22)"
          fill="#00629c"
        />
      </g>
      <polygon
        points="759.68 647.63 750.81 647.63 685.93 312.7 677.61 647.63 668.19 647.63 657.65 313.26 594.43 647.63 584.45 647.63 627.42 303.38 628.82 292.19 713.11 282.76 715.73 303.38 759.68 647.63"
        fill="#464353"
      />
      <rect x="526.98" y="215.62" width="53.65" height="33.27" fill="#464353" />
      <path
        d="M863.05,313.29l32.44-13.1h7.11a3.91,3.91,0,0,1,3.91,3.91v91.36a3.91,3.91,0,0,1-3.91,3.91h-7.11l-32.44-13.51Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <rect x="771.94" y="205.23" width="66.33" height="64.25" fill="#464353" />
      <rect x="656.8" y="84.55" width="42.7" height="7.76" fill="#514e7f" />
      <rect x="608.08" y="94.6" width="120.19" height="87.75" fill="#514e7f" />
      <rect x="608.08" y="171.96" width="120.19" height="10.4" opacity="0.1" />
      <rect x="770.91" y="205.23" width="2.69" height="64.25" opacity="0.1" />
      <rect x="562.33" y="215.62" width="18.3" height="33.27" opacity="0.1" />
      <polygon
        points="715.73 303.38 627.42 303.38 628.82 292.19 713.11 282.76 715.73 303.38"
        opacity="0.1"
      />
      <rect
        x="563.99"
        y="173.62"
        width="207.94"
        height="128.09"
        rx="10.7"
        ry="10.7"
        fill="#514e7f"
      />
      <path
        d="M837.64,201.07h.63a0,0,0,0,1,0,0v72.57a0,0,0,0,1,0,0h-.63a5.19,5.19,0,0,1-5.19-5.19V206.26A5.19,5.19,0,0,1,837.64,201.07Z"
        fill="#514e7f"
      />
      <path
        d="M870.71,188h6.73a4.29,4.29,0,0,1,4.29,4.29v90.62a4.29,4.29,0,0,1-4.29,4.29h-6.73a0,0,0,0,1,0,0V188A0,0,0,0,1,870.71,188Z"
        fill="#514e7f"
      />
      <rect x="526.98" y="215.62" width="9.57" height="33.27" opacity="0.1" />
      <rect
        x="516.17"
        y="205.23"
        width="18.71"
        height="56.56"
        rx="7.2"
        ry="7.2"
        fill="#514e7f"
      />
      <circle cx="608.08" cy="94.6" r="59.89" fill="#464353" />
      <circle cx="608.08" cy="94.6" r="44.92" fill="#00629c" />
      <circle cx="719.12" cy="95.85" r="43.67" fill="#464353" />
      <circle cx="719.12" cy="95.85" r="32.75" fill="#00629c" />
      <circle cx="715.73" cy="192.68" r="5.75" fill="#00629c" />
      <circle cx="734.02" cy="192.68" r="5.75" fill="#00629c" opacity="0.5" />
      <path
        d="M686.43,324.74l-.41-.81a36.28,36.28,0,0,1,7.26,3.34c-1-8.69-34.33-33.09-40.33-33.09s-12.67-10.36-12.67-10.36-17.33-2.67-20-5.5-20.67-1.18-25-.18-11-2.67-11-2.67-3.67-6-8.33-6-9.65-6.68-9.65-6.68-4.35-4-8.35-4.68-9-5-11.34-8.35-14-5-20.66-4-24.67-1.36-24.67-1.36c7.33-3.34,9.1-11.36,9.1-11.36-6.56-.34-23.8-14.82-23.8-14.82s.71,4.68,1.53,11.21L487,228l-.15.12a108.16,108.16,0,0,1-.15-14c0-.36.06-.72.08-1.09a31.14,31.14,0,0,0,9.76-30.69c-.18-.76-.39-1.5-.63-2.23a13.87,13.87,0,0,0,4,1h.71a5.85,5.85,0,0,0,4.39-1.94h0a4.69,4.69,0,0,0,.49-.76,1.29,1.29,0,0,0,.09-.16,5.45,5.45,0,0,0,.3-.76,2.86,2.86,0,0,0,.07-.28,6.18,6.18,0,0,0,.12-.62c0-.17,0-.35,0-.53s0-.26,0-.39a11.87,11.87,0,0,0-1-4.46c-1.05-2.58-2.56-5.13-2.45-7.92,0-.23.05-.45.08-.67.28-2.19,1.43-4.22,2.12-6.33l0-.09c.1-.31.18-.62.25-.93a2.29,2.29,0,0,0,.08-.28,8.45,8.45,0,0,0,.15-1.11s0-.05,0-.08c.26-4.18-3.11-7.83-6.93-9.52-3.42-1.52-7.33-1.93-10.46-4-3.57-2.35-5.53-6.42-8.17-9.79-3.84-4.9-9.85-8.56-16-7.86-3.79.43-7.23,2.42-11,3.19-5.73,1.19-11.79-.54-17.49.79a6,6,0,0,0-3.56,2,4.07,4.07,0,0,0-.72,1.81h0a6.91,6.91,0,0,0,0,1.82v.05a12.8,12.8,0,0,0,.31,1.71l.09.35c0,.12.05.23.08.35s.13.47.19.7c.11.39.2.78.3,1.18l0,.14c.09.41.18.82.25,1.24h0a21.06,21.06,0,0,1,.32,2.62h0a12.07,12.07,0,0,1-1.53,7.12c-2.5,4-7.81,5.77-10.12,9.94a8.62,8.62,0,0,0-1,3.25h0a8.7,8.7,0,0,0-.05,1.14v.15c0,.33,0,.66.09,1a2,2,0,0,0,0,.24,8.63,8.63,0,0,0,.2.88c0,.1.05.19.08.28a7.83,7.83,0,0,0,.4,1l0,0c1.07,2.23,3.09,4.07,3.51,6.49h0c0,.07,0,.14.05.22.23,1.82-.52,3.6-.91,5.39a6.45,6.45,0,0,0-.12.66h0c0,.07,0,.14,0,.21s0,.3,0,.46,0,.17,0,.26,0,.27,0,.4a2.46,2.46,0,0,0,0,.28c0,.13,0,.26,0,.38s0,.18,0,.27.06.25.1.37l.07.25a3.73,3.73,0,0,0,.16.35l.11.22a3.64,3.64,0,0,0,.24.35,1.67,1.67,0,0,0,.12.16,2.72,2.72,0,0,0,.46.43c1.38,1,3.53.74,4.66,2a2.37,2.37,0,0,1,.32.5l.06.12a2.76,2.76,0,0,1,.19.55h0a5.48,5.48,0,0,1,0,2.28c-.4,2-1.25,3.82-1.7,5.78-.09.4-.15.81-.2,1.22h0c0,.19,0,.37-.05.55v.12c0,.17,0,.35,0,.52s0,.09,0,.14c0,.25,0,.51.06.76s0,.24.06.35l.06.29c0,.13.07.26.11.39l.09.25c.05.14.12.28.18.42a1.74,1.74,0,0,0,.1.19,3.5,3.5,0,0,0,.36.58c1.21,1.64,3.2,2.19,5.3,2.2a16.7,16.7,0,0,0,3.54-.4c.26.61.53,1.22.82,1.81a31.07,31.07,0,0,0,5.63,7.92c0,.31-.06.61-.1.93-.23,2.28-.51,4.73-.83,7.2-2.59-1.19-4.59-1.65-5.38-.79-3.35,3.68,0,16.38,0,16.38s-16.35,0-20.35,3.67-11.33,0-11.33,0-15,1.68-14,4.69-8,0-8,0-6.34.67-6,5-9.67,6.34-8.34,9.35-6,5-6,5-7.33-.33-4.66,4h0s-4,9.36-7.33,10-7.67,8.35-7.67,8.35-12.84,2.34-12.26,6.35-19.74,32.7-19.74,32.7-6.67,13.75-2,23.78,8,16.71,9,20.38S332.1,388.09,332,391.1c0,.94,3,6,7.09,12.42l-1.2,1.24-2.63,2.71s-8.34,20.72,1.66,21.72c8.45.84,14.52,1.45,17.6.61a4.22,4.22,0,0,0,1.4-.61l.12-.09c3.64,5.37,6.22,9.12,6.22,9.12s.36-.53,1-1.44l1,1.43s.8-1.14,2.16-3c-.44,9.09-.5,18.05-.5,18.05s4.34-.67,2.34,19.38,12,36.42,12,36.42v29.75h0s0,.75.14,2c.37,4.27,1.59,14.34,5.19,21,4.67,8.68,0,31.41,0,31.41s-.31,18.54.81,41.66c0,.63.07,1.28.1,1.92-20.22,16.9-41.91,39.3-41.91,39.3a11,11,0,0,1,3,1.35L346.38,679l-5.51,6.79h0l-4.26,5.26h0l6.75,20.79,7.37-2.88s4,6.93,3.16,11.63a5,5,0,0,1-1,2.33,2.94,2.94,0,0,0-.52,1.15c-1.93,7.53,6.12,40,18.89,41.41,0,0,4.33,1.43,5.72-2.47.67-1.88.66-5-.84-10.07,0,0-6.75-8.14-2.38-16.91,2.56-5.13,6.79-12,9.85-16.85l1.26-2c2.75,3.47,4.44,5.7,4.44,5.7l9.82-10.56c.21.45.42.89.64,1.31a31.39,31.39,0,0,0,2.54,4.22l6.66,26.41,2.69-.6c-.06.64-.1,1.32-.14,2-.22,4.74,0,10.89,2.19,15.28,1.64,3.36,4.41,5.7,8.93,5.59,15.5-.38,20-8.77,20-8.77v-21l5.33-1.19s-.39-46.14-1.76-71.87c0-.57-.06-1.12-.09-1.66,0-.08,0-.16,0-.23l34.23-36.81,2.63-1.05c22-8.69,22.34-31.08,22.34-31.08s0-12.36,2.66-22.72.34-64.17-4.66-77.53-6.67-28.42-6.67-28.42,5-7,0-12.83a25.61,25.61,0,0,1-3.5-5.72l6.51-1.07,3.75-.62,2-.34c-1,8.84-1.17,15.63,1.2,17.25,7.34,5,32-11.7,32-11.7-9,0-14-67.17-12.17-68.84S531,345,528.61,339,537,306.21,537,306.21l1.66-2.46h0s39.34,17.17,43.67,20.46,18-8,20.33-3.63,17,10.88,17,10.88,21.67-2.19,24,3.16S660,352.5,660,352.5a76.33,76.33,0,0,1,.53-8.79c.29.69.57,1.39.87,2.1,6.64,15.71,17.69,35.6,27.93,24.9C700.93,358.55,692.1,336.07,686.43,324.74Zm-296.49,71,0,.19-.08-.08Zm-7.76-77.08-4.24,44.71L369.61,372l-1,1.06L360,363.69s-4.34-2,0-5.68-7.33-12-7.33-12-.34-6,4-7.68,10-12.7,10-12.7l15.67-8v0h0ZM437.94,547.5a5.3,5.3,0,0,1,1-.73c1.87-1.06,3.07.1,3.69,2.14a17.24,17.24,0,0,1-.71,10.28c-2.33,5.35,3.34,26.74,3.34,26.74s-7.34,3.33-8.67,9.69a6.61,6.61,0,0,1-1,2.18c-.09-.56-.17-1.1-.25-1.62-.65-4-1-6.58-1-6.58a42.58,42.58,0,0,1-.67-15.7c1.06-6.43,3.2-19.49,4-24.44.2-1.2.31-1.92.32-2Z"
        transform="translate(-24.78 -112.22)"
        fill="url(#b40d0b21-e963-4952-8000-4d7b7531dbb4)"
      />
      <path
        d="M484.42,221.92l2.16-1.44,6.09,12.85-2.34,2.75h-7.08s.25-7,.42-7.25S484.42,221.92,484.42,221.92Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <path
        d="M442.61,731.27v27.5s-4.5,8.37-20,8.75a9.1,9.1,0,0,1-8.93-5.57c-2.16-4.38-2.41-10.52-2.19-15.25a60,60,0,0,1,.75-7.06Z"
        transform="translate(-24.78 -112.22)"
        fill="#3f3d56"
      />
      <path
        d="M442.61,731.27v8.51l-31.12,6.92a60,60,0,0,1,.75-7.06Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M447.94,736.6l-39,8.67-6.66-26.34a31.89,31.89,0,0,1-2.54-4.21c-.43-.84-.85-1.73-1.25-2.66C391.23,695.45,388,665.49,386.62,640c-.07-1.29-.14-2.57-.2-3.83-1.12-23.06-.81-41.56-.81-41.56s4.67-22.67,0-31.33c-3.6-6.68-4.82-16.72-5.19-21-.1-1.27-.14-2-.14-2l.72-1.89,2.94-7.78h32.34l18.8,15.91,2.86,2.42-.32,2c-.81,4.94-2.95,18-4,24.38a42.37,42.37,0,0,0,.67,15.66s.39,2.54,1,6.57c.15,1,.32,2.06.51,3.21,2.39,14.78,6.87,41.77,8.78,48.22.53,1.77,1,6.21,1.35,12.22.08,1.2.15,2.45.22,3.76C447.55,690.58,447.94,736.6,447.94,736.6Z"
        transform="translate(-24.78 -112.22)"
        fill="#514e7f"
      />
      <path
        d="M442.61,758.49v.28s-4.5,8.37-20,8.75a9.1,9.1,0,0,1-8.93-5.57C420.63,763.66,431.91,764.76,442.61,758.49Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M689.28,372.6C679,383.27,668,363.43,661.35,347.76c-3.73-8.82-6.07-16.33-6.07-16.33l27.36-11.58s1.68,2.67,3.79,6.9C692.1,338.05,700.93,360.47,689.28,372.6Z"
        transform="translate(-24.78 -112.22)"
        fill="#a1616a"
      />
      <path
        d="M486.73,216.39a124.83,124.83,0,0,0,2.21,29.54s-55.66,6-50.66-2.66c2.93-5.08,4.83-18.49,5.89-28.74.77-7.26,1.11-12.93,1.11-12.93s53.33-21.33,45.33-3.33C488.22,203.64,487.11,210,486.73,216.39Z"
        transform="translate(-24.78 -112.22)"
        fill="#a1616a"
      />
      <polygon
        points="466.65 247.38 459.17 336.71 493.5 331.05 487.5 257.38 489.5 237.71 466.65 247.38"
        fill="#464353"
      />
      <polygon
        points="493.5 331.19 478.59 333.65 459.16 336.85 460.53 320.55 466.65 247.52 474.44 244.22 479.96 241.89 489.5 237.85 487.5 257.52 493.5 331.19"
        opacity="0.1"
      />
      <path
        d="M373.73,737c-4.37,8.75,2.38,16.87,2.38,16.87,1.5,5.07,1.51,8.17.84,10-1.39,3.89-5.72,2.46-5.72,2.46-13.62-1.5-21.87-38.24-18.37-42.45S350.73,710,350.73,710l-7.37,2.87-6.75-20.74,4.26-5.25,5.51-6.78,3.73-4.6,37.25,38.87s-1.59,2.39-3.78,5.82C380.52,725,376.29,731.9,373.73,737Z"
        transform="translate(-24.78 -112.22)"
        fill="#3f3d56"
      />
      <path
        d="M446.18,664.91l-46.44,49.81c-8.14-15.9-11.64-47.8-13.12-74.73,8.65-7.2,17-13.4,23.32-16.39,0,0,21.38-15.47,25.89-22.89,2.39,14.78,6.87,41.77,8.78,48.22C445.24,651.05,445.76,657,446.18,664.91Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <polygon
        points="410.3 434.29 356.22 426.16 359.16 418.38 391.5 418.38 410.3 434.29"
        opacity="0.1"
      />
      <path
        d="M446,661.15l-47.47,50.91C391.23,695.45,388,665.49,386.62,640c-.07-1.29-.14-2.57-.2-3.83,8.73-7.28,17.18-13.54,23.52-16.56,0,0,19.95-14.43,25.38-22.1.15,1,.32,2.06.51,3.21,2.39,14.78,6.87,41.77,8.78,48.22C445.14,650.7,445.58,655.14,446,661.15Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M387.36,714.39s-1.59,2.39-3.78,5.82c-7.95-10.05-26.8-33.19-37.2-40.09l3.73-4.6Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M507.94,571.59c-2.66,10.34-2.66,22.67-2.66,22.67s-.34,22.33-22.34,31l-2.63,1-91,97.63s-33.67-44-44.67-46.67c0,0,44.33-45.67,65.33-55.67,0,0,25.34-18.33,26.67-24.66s8.67-9.67,8.67-9.67-5.67-21.33-3.34-26.67a17.14,17.14,0,0,0,.71-10.25c-.62-2-1.82-3.19-3.69-2.14a5.3,5.3,0,0,0-1,.73l-57.66-8.67V510.59s-14-16.33-12-36.33-2.34-19.33-2.34-19.33.21-33.78,3.06-36.6,30.23-15.74,30.23-15.74l85.84,15.25,3.54,16.42s3,13.06,8,18.86,0,12.79,0,12.79,1.67,15,6.67,28.35S510.61,561.26,507.94,571.59Z"
        transform="translate(-24.78 -112.22)"
        fill="#514e7f"
      />
      <path
        d="M490.61,198.27c-2.39,5.37-3.5,11.77-3.88,18.12a31,31,0,0,1-42.56-1.86c.77-7.26,1.11-12.93,1.11-12.93S498.61,180.27,490.61,198.27Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M497.43,192a31,31,0,1,1-.86-7.27A31,31,0,0,1,497.43,192Z"
        transform="translate(-24.78 -112.22)"
        fill="#a1616a"
      />
      <path
        d="M472.28,245.93S450,235.6,448.61,234.26,401,351.6,401,351.6l-13,59s69.33,29.66,84.33,25.66,16.33,0,16.33,0S504,350.26,509,342.6s-4.67-85.67-4.67-85.67L487,234.25Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M472.28,241.93S450,231.6,448.61,230.26,401,347.6,401,347.6l-13,59s69.33,29.66,84.33,25.66,16.33,0,16.33,0S504,346.26,509,338.6s-4.67-85.67-4.67-85.67L487,230.25Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M508.94,340.6c-1,1.59-2.51,6.53-4.2,13.37-1.18,4.76-2.46,10.43-3.77,16.53-5.9,27.53-12.36,63.77-12.36,63.77s-.41-1.22-3.3-1.64c-2.34-.34-6.32-.15-13,1.64-15,4-84.34-25.67-84.34-25.67l2-9,11-50s46.34-118.67,47.67-117.33c.81.81,9.47,5,16.07,8.11,4.21,2,7.6,3.55,7.6,3.55l14-11.06.77-.61,17.25,22.67S513.94,332.93,508.94,340.6Z"
        transform="translate(-24.78 -112.22)"
        fill="#00629c"
      />
      <path
        d="M455.94,255.6c2,7.69-2.66,20.33-2.66,20.33s-16,39.34-20.67,57.52-31.38,54.82-31.38,54.82-3.92,3.93-9.41,9.4c-.61.61-1.25,1.24-1.89,1.9l11-50s46.34-118.67,47.67-117.33c.81.81,9.47,5,16.07,8.11C460.54,244.11,454.61,250.51,455.94,255.6Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M453.94,255.6c2,7.69-2.66,20.33-2.66,20.33s-16,39.34-20.67,57.52-31.38,54.82-31.38,54.82-3.92,3.93-9.41,9.4c-.65.65-1.33,1.32-2,2-10.72,10.67-25.79,25.63-30.5,30-.69.65-1.16,1.07-1.36,1.21a4.22,4.22,0,0,1-1.4.61c-3.08.84-9.15.23-17.6-.61-10-1-1.66-21.66-1.66-21.66l2.63-2.71,2.4-2.48L367.57,376l2-2.11,8.33-8.59,4.24-44.6.1-1.07s-1.24-2.83-3.15-7.15C374,300.79,364,278.23,360.34,270.94c-.42-.85-.75-1.48-1-1.87,0-.05-.05-.1-.08-.14-2.67-4.33,4.66-4,4.66-4s7.34-2,6-5,8.67-5,8.34-9.33,6-5,6-5,9,3,8,0,14-4.67,14-4.67,7.33,3.67,11.33,0S438,237.27,438,237.27s-3.35-12.67,0-16.34,28.47,16.34,28.47,16.34S451.94,247.92,453.94,255.6Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <path
        d="M370.61,426.26s27.67,39,47,26.34-26-45.67-26-45.67Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M370.61,424.26s27.67,39,47,26.34-26-45.67-26-45.67Z"
        transform="translate(-24.78 -112.22)"
        fill="#a1616a"
      />
      <path
        d="M503.37,445.73c2.11-18.41,8.23-46.07,3.24-54.46-2.47-4.16-4.3-12.09-5.64-20.77-.72-4.67-1.29-9.56-1.75-14.2-1.22-12.31-1.61-22.85-1.61-22.85s-12-53.52-9.67-64.52c1.46-6.88-.22-24.12-1.68-36.06l.77-.61,17.25,22.67s9.66,78,4.66,85.67c-1,1.59-2.51,6.53-4.2,13.37l9.54-4-2,19.67,6,73.67Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M486.58,220.48s17.24,14.45,23.8,14.78c0,0-1.77,8-9.1,11.34,0,0,18,2.38,24.67,1.35s18.33.65,20.66,4S554,259.6,558,260.26s8.35,4.67,8.35,4.67L537,308.26s-10.67,26.67-8.34,32.67-.34,39.67-2.17,41.33,3.17,68.67,12.17,68.67c0,0-24.66,16.67-32,11.67s9.34-59,2-71.34-9-57.82-9-57.82-12-53.51-9.66-64.51S486.58,220.48,486.58,220.48Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <path
        d="M686.43,326.75c-8.91-2.78-22.56-2.86-25.08,21-3.73-8.82-6.07-16.33-6.07-16.33l27.36-11.58S684.32,322.52,686.43,326.75Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M550,262.93l16.35,2s5,6.67,9.65,6.67,8.33,6,8.33,6,6.67,3.66,11,2.66,22.33-2.65,25,.18,20,5.49,20,5.49S647,296.26,653,296.26s39.33,24.34,40.33,33c0,0-33-21-33.33,25.17,0,0-14-12.5-16.34-17.83s-24-3.16-24-3.16-14.66-6.51-17-10.84-16,6.9-20.33,3.61-43.67-20.41-43.67-20.41l-12.17-22.87Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <circle cx="449.83" cy="188.38" r="2.83" fill="#3f3d56" />
      <circle cx="447" cy="247.47" r="2.83" fill="#3f3d56" />
      <circle cx="449.83" cy="216.37" r="2.83" fill="#3f3d56" />
      <circle cx="441.66" cy="278.57" r="2.83" fill="#3f3d56" />
      <path
        d="M377,763.92c-1.39,3.89-5.72,2.46-5.72,2.46-13.62-1.5-21.87-38.24-18.37-42.45S350.73,710,350.73,710l-7.37,2.87-6.75-20.74,4.26-5.25c4.24,7.35,10.31,17.92,11.74,20.62a37.73,37.73,0,0,1,3.75,18C356.13,732,363.67,763.08,377,763.92Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M496.57,184.69c-.68-.23-1.36-.5-2-.77-2.29-.93-4.7-2-6.09-4-1.27-1.86-1.68-4.48-3.66-5.54-2.28-1.22-5,.43-7.47,1-2.94.69-6-.13-8.86-1.18-4.26-1.57-10.21-4.46-14.58-1.47-3.4,2.32-2.08,7.24-2.95,10.75-1.35,5.45-7.14,9-8.23,14.51-.49,2.43-.17,5.4-2.14,6.91a5.1,5.1,0,0,1-1.92.84,31,31,0,1,1,57.93-21Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M468.47,172.17c2.83,1.05,5.91,1.87,8.86,1.17,2.51-.59,5.18-2.24,7.46-1,2,1.07,2.4,3.68,3.66,5.54,1.39,2,3.8,3.12,6.1,4a17.33,17.33,0,0,0,5.43,1.52,6.15,6.15,0,0,0,5.1-1.93c1.78-2.15,1.24-5.37.18-7.94s-2.56-5.13-2.45-7.91c.13-3.3,2.52-6.17,2.72-9.46.26-4.17-3.11-7.81-6.93-9.5-3.42-1.51-7.33-1.93-10.46-4-3.57-2.34-5.53-6.4-8.17-9.76-3.84-4.89-9.85-8.54-16-7.84-3.79.43-7.23,2.41-11,3.18-5.73,1.19-11.79-.54-17.49.79a6,6,0,0,0-3.56,1.95c-1.4,1.88-.68,4.51-.06,6.77,1.11,4.07,1.58,8.68-.63,12.26-2.5,4.05-7.81,5.76-10.12,9.92a8.8,8.8,0,0,0-.23,8c1.1,2.3,3.23,4.17,3.56,6.7.23,1.82-.52,3.59-.91,5.37s-.28,4,1.19,5,3.53.75,4.66,2a4,4,0,0,1,.53,3.44c-.4,2-1.25,3.81-1.7,5.77a7.07,7.07,0,0,0,.77,5.77c1.94,2.62,5.86,2.46,9,1.76a6.27,6.27,0,0,0,2.53-1c2-1.51,1.65-4.48,2.14-6.91,1.09-5.5,6.88-9.07,8.23-14.51.87-3.51-.45-8.44,2.95-10.76C458.25,167.71,464.21,170.6,468.47,172.17Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <path
        d="M463.61,533.93S495,553.93,496,561.6Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M462,549.93s36,17.33,34,23.33Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M459.61,565.26s20.34,10.67,21.67,17Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M468.28,589.26s13.33,11.67,16,8.67S468.28,589.26,468.28,589.26Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M449.61,596.6S460,613.26,455,614.26,449.61,596.6,449.61,596.6Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M404,300.6s-17.67,10.66-12.34,13.33S404,300.6,404,300.6Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M404,261.26s-18,33-9.67,30.67S404,261.26,404,261.26Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M595.28,294.26s-11,12.94-9,20Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M624,300.6s-16.51,14.66-14.09,16.33Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M634.28,318.61s-1.67,9.64,1,10Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M454.11,522c-4.25,5.5-4.25,15.25-6.17,19.25-1.05,2.2-3.39,6-5.29,9.08-.62-2-1.82-3.19-3.69-2.14-1.23-9.17-3.4-25-4.1-28.19-1-4.5,10-16.5,10-16.5s10.75,2.25,13.5,7.75S458.36,516.51,454.11,522Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.05"
      />
      <path
        d="M398.61,406.27c-12,1.66-34.33,33.66-34.33,33.66s-2.93-4.26-7-10.21c-5.12-7.55-12-17.84-17-25.64l29.3-30.22,5.33,5.74s10.34,10.33,10.34,12.33c0,.78,2,3.15,4.54,5.74C393.68,401.7,398.61,406.27,398.61,406.27Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M360.34,270.94c-.42-.85-.75-1.48-1-1.87l12.92.86,6.85,42.52C374,300.79,364,278.23,360.34,270.94Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M387.8,399.7c-10.72,10.67-25.79,25.63-30.5,30-.69.65-1.16,1.07-1.36,1.21a4.22,4.22,0,0,1-1.4.61c-4.71-6.92-11.43-16.89-16.63-25l2.4-2.48L367.57,376l3.37,3.63s10.34,10.33,10.34,12.33C381.28,392.92,384.51,396.4,387.8,399.7Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M374.28,269.93l-15-1s-4,9.33-7.33,10-7.67,8.33-7.67,8.33S331.44,289.6,332,293.6s-19.74,32.61-19.74,32.61-6.67,13.72-2,23.72,8,16.67,9,20.33S332.1,389.93,332,392.93s30.26,47,30.26,47,22.33-32,34.33-33.67c0,0-13.33-12.33-13.33-14.33S373,379.6,373,379.6l-13-14s-4.34-2,0-5.67-7.33-12-7.33-12-.34-6,4-7.67,10-12.66,10-12.66l15.67-8Z"
        transform="translate(-24.78 -112.22)"
        fill="#464353"
      />
      <path
        d="M317,336.26s18-3.66,18.33-1.33S317,336.26,317,336.26Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M332,354.43s15.26,2,14.59,5.26S332,354.43,332,354.43Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <path
        d="M344.61,297.76s14.67,20.77,16.67,16.47Z"
        transform="translate(-24.78 -112.22)"
        opacity="0.1"
      />
      <g opacity="0.1">
        <path
          d="M432.76,143a22.42,22.42,0,0,0-.9-7.17,22.22,22.22,0,0,1-.66-3,12.29,12.29,0,0,0,.66,5A25.79,25.79,0,0,1,432.76,143Z"
          transform="translate(-24.78 -112.22)"
        />
        <path
          d="M502.89,165c.39-3,2.45-5.73,2.64-8.8a7.78,7.78,0,0,0-.06-1.53c-.39,3.1-2.54,5.85-2.66,9A7.48,7.48,0,0,0,502.89,165Z"
          transform="translate(-24.78 -112.22)"
        />
        <path
          d="M505.08,179.5a6.15,6.15,0,0,1-5.1,1.93,17.33,17.33,0,0,1-5.43-1.52c-2.3-.93-4.71-2-6.1-4-1.27-1.86-1.68-4.47-3.66-5.54-2.28-1.22-5,.43-7.47,1-2.94.7-6-.12-8.85-1.17-4.26-1.57-10.22-4.46-14.59-1.48-3.4,2.32-2.08,7.25-2.95,10.76-1.35,5.44-7.14,9-8.23,14.51-.49,2.43-.17,5.4-2.14,6.91a6.26,6.26,0,0,1-2.54,1c-3.18.7-7.1.86-9-1.76a5.35,5.35,0,0,1-1-2.55,6.32,6.32,0,0,0,1,4.55c1.94,2.62,5.86,2.46,9,1.76a6.26,6.26,0,0,0,2.54-1c2-1.51,1.65-4.48,2.14-6.91,1.09-5.5,6.88-9.07,8.23-14.51.87-3.51-.45-8.44,2.95-10.76,4.37-3,10.33-.09,14.59,1.48,2.83,1.05,5.91,1.87,8.85,1.17,2.52-.59,5.19-2.24,7.47-1,2,1.07,2.39,3.68,3.66,5.54,1.39,2,3.8,3.12,6.1,4a17.33,17.33,0,0,0,5.43,1.52,6.15,6.15,0,0,0,5.1-1.93,5.91,5.91,0,0,0,1.08-4.59A5,5,0,0,1,505.08,179.5Z"
          transform="translate(-24.78 -112.22)"
        />
        <path
          d="M424.44,172.67c-.33-2.53-2.46-4.4-3.56-6.7a8.5,8.5,0,0,1-.78-2.75,8.71,8.71,0,0,0,.78,4.75c1.07,2.23,3.09,4.07,3.51,6.48A6.24,6.24,0,0,0,424.44,172.67Z"
          transform="translate(-24.78 -112.22)"
        />
        <path
          d="M430,188.29a3.8,3.8,0,0,0-.57-3.17c-1.13-1.29-3.28-1-4.66-2a3.5,3.5,0,0,1-1.31-2.38c-.22,1.63,0,3.43,1.31,4.38s3.53.75,4.66,2A2.73,2.73,0,0,1,430,188.29Z"
          transform="translate(-24.78 -112.22)"
        />
      </g>
      <path
        d="M192.62,706.21s-41.36-2.5-36.49,26.49c0,0-1,5.12,3.68,7.45,0,0,.07-2.15,4.24-1.42a19,19,0,0,0,4.49.21,9.4,9.4,0,0,0,5.5-2.26h0s11.63-4.81,16.15-23.81c0,0,3.34-4.15,3.21-5.21l-7,3s2.39,5,.51,9.22c0,0-.23-9-1.57-8.83-.27.05-3.63,1.75-3.63,1.75s4.11,8.77,1,15.15c0,0,1.18-10.81-2.29-14.52l-4.91,2.87s4.8,9.06,1.54,16.46c0,0,.84-11.34-2.57-15.76l-4.46,3.47s4.51,8.93,1.76,15.07c0,0-.36-13.21-2.72-14.2,0,0-3.9,3.43-4.49,4.84,0,0,3.08,6.49,1.17,9.91,0,0-1.17-8.8-2.14-8.84,0,0-3.88,5.83-4.28,9.82,0,0,.17-5.94,3.34-10.38a11.73,11.73,0,0,0-5.94,3.08s.6-4.12,6.9-4.48c0,0,3.21-4.42,4.07-4.69,0,0-6.27-.52-10.06,1.16,0,0,3.34-3.88,11.2-2.12l4.4-3.59s-8.24-1.12-11.74.12c0,0,4-3.44,12.93-.93l4.78-2.86s-7-1.52-11.22-1c0,0,4.42-2.38,12.62.2l3.43-1.54s-5.15-1-6.66-1.17-1.59-.58-1.59-.58a17.91,17.91,0,0,1,9.67,1.08S192.75,706.66,192.62,706.21Z"
        transform="translate(-24.78 -112.22)"
        fill="#00629c"
      />
      <ellipse
        cx="139.35"
        cy="630.46"
        rx="29.28"
        ry="4.95"
        fill="#00629c"
        opacity="0.1"
      />
    </svg>
  );
}
